import Cookies from 'js-cookie';

// These are the legacy inventory routes only; other application requests are untouched.
const routes = [
  ['post', /^\/api\/(?:storeRegister|itemRegister|supplyRegister|staffRegister|purchaseBill|stockTransfer|stockTransferByUnit)$/],
  ['get', /^\/api\/(?:store|item|supply|staff|getPurchaseBill|getTransfer|getTransferSalesSummary)\/[^/]+$/],
  ['get', /^\/api\/getPurchaseBill\/[^/]+\/[^/]+$/],
  ['get', /^\/api\/getStoreItems\/[^/]+\/[^/]+$/],
  ['put', /^\/api\/(?:storeUpdate|itemUpdate|supplyUpdate|staffUpdate|updatePurchaseBill)\/[^/]+\/[^/]+$/],
  ['delete', /^\/api\/(?:storeDelete|itemDelete|supplyDelete|staffDelete|deletePurchaseBill)\/[^/]+\/[^/]+$/],
];

const installed = new WeakMap();

function isInventoryRequest(config, apiOrigin) {
  try {
    const origin = new URL(apiOrigin).origin;
    const raw = config.url || '';
    const base = config.baseURL || window.location.origin;
    const url = /^https?:\/\//i.test(raw) ? new URL(raw) : new URL(raw, `${base.replace(/\/+$/, '')}/`);
    return url.origin === origin && routes.some(([method, path]) =>
      method === (config.method || 'get').toLowerCase() && path.test(url.pathname));
  } catch (_) {
    return false;
  }
}

export function presentInventorySignIn({
  confirm = () => window.confirm('Your inventory sign-in is missing or expired. The current page and unsaved changes will stay open if you choose Cancel. Go to sign in now?'),
  leave = () => {
    Cookies.remove('token');
    localStorage.removeItem('token');
    localStorage.removeItem('customerId');
    window.location.assign('/login');
  },
} = {}) {
  if (!confirm()) return false;
  leave();
  return true;
}

export function installInventoryCompatibility(axiosClient, { readToken, apiOrigin, onAuthRequired } = {}) {
  if (installed.has(axiosClient)) return installed.get(axiosClient);
  if (!axiosClient?.interceptors || typeof readToken !== 'function' || !apiOrigin) {
    throw new Error('Axios client, token reader and API origin are required.');
  }
  let notifiedFor;
  const notify = token => {
    if (notifiedFor === token) return;
    notifiedFor = token;
    onAuthRequired?.();
  };
  const requestId = axiosClient.interceptors.request.use(config => {
    if (!isInventoryRequest(config, apiOrigin)) return config;
    const token = readToken();
    if (!token) {
      notify(null);
      return Promise.reject(Object.assign(new Error('Inventory sign-in required.'), {
        code: 'INVENTORY_AUTH_REQUIRED', status: 401, config,
      }));
    }
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  const responseId = axiosClient.interceptors.response.use(response => response, error => {
    if (error?.response?.status === 401 && error.config && isInventoryRequest(error.config, apiOrigin)) {
      const token = readToken();
      if (!token || error.config.headers?.Authorization === `Bearer ${token}`) notify(token || null);
    }
    return Promise.reject(error);
  });
  const cleanup = () => {
    axiosClient.interceptors.request.eject(requestId);
    axiosClient.interceptors.response.eject(responseId);
    installed.delete(axiosClient);
  };
  installed.set(axiosClient, cleanup);
  return cleanup;
}

